import "./style.scss";
import CustomizedInput from "../CreateForm/InputBase";
import { HeaderText } from "../../pages/CreateForm/styled";
import Button from "../Button";

interface Props {
  setOpen: (open: boolean) => void;
  title: string;
  setResponse: (value: string) => void;
  response: string;
  handleSave: (value: string) => void;
  btnLoading: boolean
}

const AddGroupPopup = ({
  setOpen,
  title,
  setResponse,
  response,
  handleSave,
  btnLoading
}: Props) => {
  return (
    <div className="popup-container">
      <div className="group-popup">
        <div className="popup-content">
          <HeaderText>{title}</HeaderText>
          <CustomizedInput
            placeholder="Enter the Group name"
            value={response}
            error={""}
            onChange={(e: any) => {
              setResponse(e.target.value);
            }}
          />
          <div className="popup-footer">
            <Button
              btn_text="Cancel"
              type="button"
              onClick={() => {
                setResponse("");
                setOpen(false);
              }}
            />
            <Button
              btn_text={btnLoading ? "Saving..." : "Save"}
              disable={btnLoading || response?.length === 0}
              type="button"
              onClick={() => {
                handleSave(response);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddGroupPopup;
